// クリエイター称号: 習熟度レベル(1-3)に対応。CreatorStudioのtier表記(ビギナー/クリエイター/マスター)と整合。
export interface CreatorTitle {
    name: string;
    cls: string; // 背景+文字色クラス（枠線・角丸は呼び出し側で付与）
}

export const getCreatorTitle = (level: number): CreatorTitle => {
    if (level >= 3) return { name: 'マスター', cls: 'bg-sun text-ink' };
    if (level >= 2) return { name: 'クリエイター', cls: 'bg-primary-soft text-primary-dark' };
    return { name: 'ビギナー', cls: 'bg-role-voice/15 text-[#0a7d72]' };
};
